<div class="text-right">
  <span *ngIf="readonly && borderless">{{ percent }}%</span>
</div>

<nz-input-group *ngIf="!readonly || (readonly && !borderless)" nzSuffix="%">
    <input
      nz-input
      [readOnly]="readonly && !borderless"
      [(ngModel)]="percent"
      (ngModelChange)="valueChanged($event)"
      app-number-input
      [precision]="1"
      class="text-right" [class.bg-grey-lighter]="readonly && !borderless"
    />
</nz-input-group>
